/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

export type TaskFilterFields =
  (typeof TaskFilterFields)[keyof typeof TaskFilterFields];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TaskFilterFields = {
  Title: "title",
  Description: "description",
  Assignee: "assignee",
  Watcher: "watcher",
  DueDate: "duedate",
  StartDate: "startdate",
  ModifiedOn: "modifiedon",
  StatusModifiedOn: "statusmodifiedon",
  ModifiedBy: "modifiedby",
  StatusModifiedBy: "statusmodifiedby",
  Status: "status",
  TaskType: "tasktype",
  Tag: "tag",
  TextCustomField: "textcustomfield",
  BooleanCustomField: "booleancustomfield",
  NumberCustomField: "numbercustomfield",
  DateCustomField: "datecustomfield",
  EnumCustomField: "enumcustomfield",
  EnumCustomFieldSingle: "enumcustomfieldsingle",
  UserCustomField: "usercustomfield",
  UserCustomFieldSingle: "usercustomfieldsingle",
  SubCustomField: "subcustomfield",
  SubCustomFieldSingle: "subcustomfieldsingle",
} as const;
